import dayjs from "dayjs";
import capitalize from "lodash.capitalize";

export const adaptCarouselBanner = (banner: IBanner): Banner => {
	return {
		id: banner.id,
		bannerType: capitalize(banner.banner_type),
		buttonLink: banner.button_link,
		buttonStyle: banner.button_style,
		buttonText: banner.button_text,
		buttonVisible: banner.button_visible,
		contentColor: banner.content_color,
		backgroundColor: banner.background_color,
		foregroundColor: banner.foreground_color,
		contentText: banner.content_text,
		headingText: banner.heading_text,
		imageLandscapeUuid: banner.image_landscape_uuid,
		imagePortraitUuid: banner.image_portrait_uuid,
		createdAt: dayjs(banner.created_at).format("DD MMM YYYY"),
		monthCreated: banner.created_at_month,
		yearCreated: banner.created_at_year,
		createdBy: banner.created_by
			? {
					id: banner.created_by.id,
					firstName: banner.created_by.first_name,
					lastName: banner.created_by.last_name
			  }
			: undefined,
		updatedAt: dayjs(banner.updated_at).format("DD MMM YYYY"),
		imageUuid: banner.image_uuid,
		videoUuid: banner.video_uuid,
		name: banner.name,
		order: banner.order,
		published: banner.published,
		template: banner.template,
		variant: banner.variant && capitalize(banner.variant),
		activeDays: banner.active_days,
		subheadingText: banner.subheading_text
	};
};

export const adaptCarouselBanners = (data: IBanner[]): Banner[] => {
	return data.map(adaptCarouselBanner);
};
